import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './i18n/config';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import { useSelector } from 'react-redux';
// import { history } from './utils/history';
import history from './utils/history';

// Layout Components
import Layout from './components/layout/Layout';

// Auth Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import RegisterEmployee from './pages/auth/RegisterEmployee';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import Verification from './pages/verification/Verification';

// Main Pages
import Dashboard from './pages/dashboard/Dashboard';
import Customers from './pages/customers/Customers';
import Employees from './pages/employees/Employees';
import Transactions from './pages/transactions/Transactions';
import Mosads from './pages/mosads/Mosads';
import NewMosad from './pages/mosads/NewMosad';
import MosadDetails from './pages/mosads/MosadDetails';
import Banks from './pages/banks/Banks';
import Profile from './pages/auth/Profile';
// import Settings from './pages/Settings';
import Billing from './pages/billing/Billing';
import NotFound from './pages/NotFound';

import { registerLicense } from '@syncfusion/ej2-base';
registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXxfcHRWR2NcVkB3W0E=');

const PrivateRouteComponent = ({ children }) => {
  const { isAuthenticated } = useSelector(state => state.auth);
  const { selectedMosadCode, firstLoginCompleted } = useSelector(state => state.user);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!firstLoginCompleted || !selectedMosadCode) {
    return <Navigate to="/mosads" />;
  }

  return children;
};

function App() {
  return (
    <>
      <Routes>
        {/* Auth Routes */}
        <Route path="/login" element={<Login history={history}/>} />
        <Route path="/register" element={<Register history={history}/>} />
        <Route path="/register/:empId/:mosadSn" element={<RegisterEmployee />} />
        <Route path="/verifyEmail/:usrId/:uniqueString" element={<Verification />} />
        <Route path="/forgot-password" element={<ForgotPassword history={history}/>} />
        <Route path="/reset-password" element={<ResetPassword history={history}/>} />
        {/* <Route path="/settings" element={<Settings />} /> */}
        <Route path="/mosads" element={<Mosads history={history}/>} />
        <Route path="/mosads/new" element={<NewMosad />} />
      
        {/* Protected Routes */}
        <Route path="/" element={
            <PrivateRouteComponent>
              <Layout />
            </PrivateRouteComponent>
          }>
          <Route path="/profile" element={<Profile />} />
          <Route path="" element={<Navigate to="/dashboard" />} />        
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="customers" element={<Customers />} />
          <Route path="employees" element={<Employees />} />
          <Route path="billing" element={<Billing />} />
          <Route path="transactions" element={<Transactions />} />
          <Route path="banks" element={<Banks />} /> 
          <Route path="/mosads/:id" element={<MosadDetails />} />
        </Route>

        {/* Default Route */}
        <Route path="/" element={<Navigate to="/dashboard" />} />

        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      <ToastContainer
        position="top-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App; 